import { If, TabLink } from "components";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { Routes } from "modules/common";
import {
  AboutUs,
  Privacy,
  Videos,
  Socials,
  FAQ,
  Quiz,
  InfoBar,
  Feed,
  Announcements
} from "modules/content";
import { useParams } from "react-router-dom";

import styles from "./ContentPage.module.scss";

const ContentPage = () => {
  const { activeTab } = useParams();
  const contentRoutes = Routes.find((route) => {
    return route.label === "Content";
  })?.nestedRoutes;

  return (
    <ContentLayout title={t("Content")}>
      <BoxShadowLayout className={styles.pageContent}>
        <If condition={!!contentRoutes}>
          <nav>
            {contentRoutes?.map((route) => (
              <TabLink
                key={route.label}
                pathName={route.path}
                label={route.label}
              />
            ))}
          </nav>
        </If>

        <div className={styles.pageContent_content}>
          <If condition={activeTab === "privacy"}>
            <Privacy />
          </If>

          <If condition={activeTab === "video"}>
            <Videos />
          </If>

          <If condition={activeTab === "about"}>
            <AboutUs />
          </If>

          <If condition={activeTab === "social"}>
            <Socials />
          </If>

          <If condition={activeTab === "faq"}>
            <FAQ />
          </If>

          <If condition={activeTab === "quiz"}>
            <Quiz />
          </If>

          <If condition={activeTab === "info-bar"}>
            <InfoBar />
          </If>

          <If condition={activeTab === "feed"}>
            <Feed />
          </If>

          <If condition={activeTab === "announcements"}>
            <Announcements />
          </If>
        </div>
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default ContentPage;
